import { ArrowLeft, X } from 'lucide-react';
import Portal from './Portal';
import { useShake } from '../ShakeProvider';
import JobList from './JobList';
import ShakeTemplateForm from './form/ShakeTemplateForm';

export default function ShakeModal() {
  const { isModalOpen, setModalOpen, selectedTemplate, view, goBack, headerTitle } = useShake();
  if (!isModalOpen || !selectedTemplate) return null;

  const showBack = view === 'job-form' || view === 'job-view';

  return (
    <Portal>
      <div className="shakeScope">
        <div
          className="fixed inset-0 z-50 bg-overlay backdrop-blur-sm"
          onClick={() => setModalOpen(false)}
        />
        <section
          className="fixed inset-4 z-50 mx-auto grid max-w-[1000px] grid-rows-[auto_1fr] overflow-hidden rounded-2xl border border-border/60 bg-card shadow-2xl max-md:inset-2.5"
          aria-modal="true"
          role="dialog"
        >
          <header className="flex items-center justify-between border-b border-border/60 bg-foreground px-5 py-3 text-card max-md:px-3 max-md:py-2.5 max-md:flex-wrap max-md:gap-2">
            <div className="flex items-center gap-3 max-md:gap-2">
              {showBack && (
                <button
                  className="flex items-center gap-2 bg-transparent border-0 text-card text-sm font-semibold cursor-pointer transition-opacity hover:opacity-80"
                  onClick={goBack}
                  aria-label="Back"
                >
                  <ArrowLeft size={16} /> Back
                </button>
              )}
            </div>
            <div className="flex gap-4 text-sm max-md:gap-2 max-md:flex-wrap">
              <span className="text-card/60">{selectedTemplate.name}</span>
              {showBack && (
                <span className="font-semibold text-card">{headerTitle}</span>
              )}
            </div>

            <button
              className="rounded-lg p-1.5 bg-transparent border-0 text-card cursor-pointer transition-colors hover:bg-card/10"
              aria-label="Close"
              onClick={() => setModalOpen(false)}
            >
              <X size={18} />
            </button>
          </header>

          <div className="overflow-auto p-5 max-md:p-3">
            {view === 'template' && <JobList template={selectedTemplate} />}
            {(view === 'job-form' || view === 'job-view') && <ShakeTemplateForm />}
          </div>
        </section>
      </div>
    </Portal>
  );
}
